
(function () {
    'use strict';

    angular.module(modules.printingModule, [])
           .controller(controllers.printingController, printController);

    printController.$inject = ['$scope'];

    function printController($scope) {
        $scope.init = function () {
            getGridSetting();
            $scope.columnsSetting = commonGridSetting;
            window.print();
        };
    };

})();